import { ComponentPublicInstance } from 'vue';
import { RouteLocationRaw, Router } from 'vue-router';

/**
 * Сбрасывает query параметры текущего роута
 * @param component - контекст Vue компонента
 */
export const resetCurrentRouteQuery = (component: ComponentPublicInstance): void => {
  if (component.$route?.name) {
    component.$router.replace({
      name: component.$route.name,
    });
  }
};

/**
 * Получает полный путь с query параметрами
 * @param router - экземпляр Vue Router
 * @param route - объект роута (name или path с query)
 * @returns строка с путем и query параметрами (например: "/path?param1=value1&param2=value2")
 */
export const getRoutePathWithQuery = (router: Router, route: RouteLocationRaw): string => {
  const resolved = router.resolve(route);

  if (!resolved.query || Object.keys(resolved.query).length === 0) {
    return resolved.path;
  }

  const params = new URLSearchParams();
  Object.entries(resolved.query).forEach(([key, value]) => {
    if (value !== null && value !== undefined) {
      if (Array.isArray(value)) {
        value.forEach((item) => {
          if (item !== null && item !== undefined) {
            params.append(key, String(item));
          }
        });
      } else {
        params.append(key, String(value));
      }
    }
  });

  const queryString = params.toString();
  return queryString ? `${resolved.path}?${queryString}` : resolved.path;
};
